import { Container } from '@chakra-ui/react'
import { DocumentRenderer } from '@/components'
import Head from 'next/head'
import { MainLayout } from '@/layouts'
import { PrivacyPolicyProps } from '@/pages/privacy-policy'

const PrivacyPolicy = (props: PrivacyPolicyProps) => {
  return (
    <MainLayout>
      <Head>
        <title>Privacy Policy | Chacra Software Solutions</title>
      </Head>
      <Container minH="100vh" maxW="container.xl" pt="10" pb="75">
        {props.privacyPolicies && (
          <DocumentRenderer
            document={props.privacyPolicies[0].content?.document}
          />
        )}
      </Container>
    </MainLayout>
  )
}

export default PrivacyPolicy
